var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationItem(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#FFEFE6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.3334 18.1334L26.8089 15.7006C26.9597 15.595 27.1676 15.6317 27.2731 15.7825C27.3123 15.8385 27.3334 15.9052 27.3334 15.9736V24.0265C27.3334 24.2106 27.1841 24.3599 27.0001 24.3599C26.9317 24.3599 26.8649 24.3388 26.8089 24.2996L23.3334 21.8667V24.6667C23.3334 25.0349 23.0349 25.3334 22.6667 25.3334H13.3334C12.9652 25.3334 12.6667 25.0349 12.6667 24.6667V15.3334C12.6667 14.9652 12.9652 14.6667 13.3334 14.6667H22.6667C23.0349 14.6667 23.3334 14.9652 23.3334 15.3334V18.1334ZM15.3334 17.3334V18.6667H16.6667V17.3334H15.3334Z",
    fill: "#FB8441"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationItem);
export default __webpack_public_path__ + "static/media/notification_item.67df2fb5620d0e4b10dd5235910040cb.svg";
export { ForwardRef as ReactComponent };